import React from "react";
import styled from "styled-components";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavContext } from "../../../context/nav_context";
import useStreamingData from "../hooks/useStreamingData";
import StreamerOptions from "./StreamerOptions";
import StreamingDetails from "./StreamingDetails";
import ScheduledStreaming from "./ScheduledStreaming";
import "dayjs/locale/es";

const StreamerMenu = ({ matchId, tournamentId, isAdmin }) => {
  const { user, accessToken } = useNavContext();
  const {
    selectedOption,
    dateTime,
    showDateTimePicker,
    setShowDateTimePicker,
    url,
    setUrl,
    isUrlSaved,
    streamerName,
    isStreamer,
    handleSaveUrl,
    handleDateTimeChange,
    deleteStreaming,
    handleFutureSelectedOption,
  } = useStreamingData({ matchId, tournamentId, user, accessToken });

  if (!isStreamer && !selectedOption) return null;

  return (
    <Block>
      {isStreamer && !selectedOption && (
        <SectionTitle>STREAMING</SectionTitle>
      )}
      {!isStreamer && selectedOption && (
        <SectionTitle>STREAMING</SectionTitle>
      )}

      {isStreamer && selectedOption === null && (
        <StreamerOptions
          onOptionSelect={(option) => {
            if (option === "transmitido") {
              handleFutureSelectedOption(option);
            } else {
              setShowDateTimePicker(true);
              handleFutureSelectedOption(option);
            }
          }}
        />
      )}

      {showDateTimePicker && (
        <DatePickerWrap>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <StaticDateTimePicker
              ampm={false}
              orientation="portrait"
              openTo="day"
              views={["day", "hours", "minutes"]}
              onAccept={handleDateTimeChange}
              onClose={() => setShowDateTimePicker(false)}
              localeText={{
                toolbarTitle: "Selecciona fecha y hora",
              }}
              sx={{
                ".MuiPaper-root": {
                  background: "#1a1a1a",
                  color: "#e9e9e9",
                },
                ".MuiToolbar-root": {
                  color: "#3cffd0",
                },
                ".MuiClock-pin": {
                  background: "#3cffd0",
                },
                ".MuiClockPointer-root": {
                  background: "#3cffd0",
                },
                ".MuiClockPointer-thumb": {
                  border: "2px solid #3cffd0",
                },
                ".Mui-selected": {
                  background: "#3cffd0 !important",
                  color: "#000 !important",
                },
                ".MuiDayCalendar-weekDayLabel": {
                  color: "#949494",
                },
                ".MuiPickersCalendarHeader-label": {
                  color: "#e9e9e9",
                },
                ".MuiSvgIcon-root": {
                  color: "#949494",
                },
                ".MuiInputBase-root": {
                  color: "#e9e9e9",
                },
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(255,255,255,0.06)",
                },
              }}
            />
          </LocalizationProvider>
        </DatePickerWrap>
      )}

      {!showDateTimePicker &&
        (selectedOption === "directo" || selectedOption === "diferido") &&
        dateTime && (
          <ScheduledStreaming
            dateTime={dateTime}
            selectedOption={selectedOption}
            streamerName={streamerName}
            onEditClick={() => handleFutureSelectedOption(selectedOption)}
            onDeleteClick={deleteStreaming}
            isStreamer={isStreamer}
          />
        )}

      {selectedOption === "transmitido" && (
        <StreamingDetails
          isUrlSaved={isUrlSaved}
          url={url}
          setUrl={setUrl}
          handleSaveUrl={handleSaveUrl}
          streamerName={streamerName}
          onDeleteClick={deleteStreaming}
          isStreamer={isStreamer}
        />
      )}
    </Block>
  );
};

const Block = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const DatePickerWrap = styled.div`
  margin-top: 0.75rem;
`;

export default StreamerMenu;
